import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const Container = styled.div`
  min-height: 204px;
  width: 284px;
  display: flex;
  background: ${({ theme }) => theme.colors.grey0};
  border-radius: 16px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 63px;
  right: 0;
  opacity: ${({ isOpened }) => (isOpened ? '1' : '0')};
  pointer-events: ${({ isOpened }) => (isOpened ? 'all' : 'none')};
  transition: opacity 0.7s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    right: 20%;
    margin-left: -5px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent white transparent;

    @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
      right: 11%;
    }
  }

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    width: 340px;
    min-height: 160px;
    max-height: 190px;
    flex-direction: row;
    right: 44px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    right: 20px;
  }
`

export const CloseIcon = styled(Button)`
  position: absolute;
  top: 0;
  right: 0;
`

export const NotificationContainer = styled.div`
  position: fixed;
  top: 0;
  pointer-events: none;
  height: 30px;
  z-index: 99999;
  left: 0;
  right: 0;
  width: calc('100% - 54px') %;
  justify-content: center;
  display: flex;
  align-items: center;
`

export const NotificationContent = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  max-width: 1440px;
  padding: 0 12px;
  height: 20px;

  width: calc(100% - 60px);
  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    width: calc(100% - 45px);
  }
`
